import React, { forwardRef, useImperativeHandle } from "react";
import ReactDOM from "react-dom";
import ModalSimple from "../../../../components/Layout/Modals/ModalSimple";
import ModalSpecial from "../../../../components/Layout/Modals/ModalSpecial";
import LayoutOfTablesModal from "./layoutOfTablesModal";
import CategoryFilterModal from "./categoryFilterModal";
import SupplierFilterModal from "./SupplierFilterModal";
import StatusFilterModal from "./StatusFilterModal";
import OrderShowModal from "../../../../components/common/GlobalModals/Orders/NordrentOrderShowModal";
import { getSuppliersOption } from "../../../../redux/Actions/supplierAction";
import { removeOverFlow, addOverFlow } from "../../../../helpers/modalFunc";
import OrderCreateModal from "../../../../components/common/GlobalModals/Orders/OrderCreateModal";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../../../components/common/Spinner";
import { CommentStateType } from "../../../../components/common/CommentState_type";
import { onFilterUpdateWithUser } from "../../../../redux/Actions/filtersAction";
import { setNordrentOrderSettings } from "../../../../redux/Actions/orderAction";
import ModalActionHistory from "../features/action_history/ModalActionHistory";
import { Alert } from "../../../../components/globals";

const Modal = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const order_id = useSelector((state) => state.orders.order?.id_order || "");
  const { loading_order, error_order } = useSelector((state) => state.orders);
  const validate_comments = useSelector(
    (state) => state.orders.validate_comments
  );

  const [display, setDisplay] = React.useState("first");
  const [SupplySupplierData, setSupplySupplierData] = React.useState([]);
  useImperativeHandle(ref, () => {
    return {
      openModal: (active) => open(active),
      close: () => close(),
      active: display,
    };
  });

  const open = (active) => {
    requestOfOptions();
    addOverFlow();
    setDisplay(active);
  };

  const close = () => {
    removeOverFlow();
    setDisplay(false);
  };

  const requestOfOptions = () => {
    getSuppliersOption().then((response) => {
      if (response.data) {
        let newArray = [];
        response.data.data.forEach((item) => {
          const findIndex = newArray.findIndex(
            (find) => find.name == item.name
          );
          if (findIndex == -1) {
            return newArray.push({
              value: item.id,
              name: item.name,
              code: item.code,
              label: item.title || item.name,
              is_code: item.is_code,
            });
          }
        });
        setSupplySupplierData(newArray);
      }
    });


    console.count("Request times:");
  };

  if (display == "LayoutOfTablesModal") {
    return ReactDOM.createPortal(
      <ModalSimple
        text={"Table layout"}
        handleSave={() => { }}
        onClose={() => close()}
      >
        <LayoutOfTablesModal
          layoutOfTable={props.layoutOfTable}
          layoutOfTablesFunc={props.layoutOfTablesFunc}
        />
      </ModalSimple>,
      document.getElementById("modal-roots")
    );
  }

  if (display == "CategoryFilterModal") {
    return ReactDOM.createPortal(
      <ModalSimple
        text={"Filter by categories"}
        secondButton={() =>
          dispatch(
            onFilterUpdateWithUser([], "user_categories", "categoryFilter")
          )
        }
        secondButtonText="Clear the category filter"
        onClose={() => {
          close();
          // props.updateOrderFilter();
        }}
      >
        <CategoryFilterModal />
      </ModalSimple>,
      document.getElementById("modal-roots")
    );
  }
  if (display == "ModalActionHistory") {
    return ReactDOM.createPortal(
      <ModalSimple
        text={"Actions history"}
        onClose={() => {
          close();
        }}
      >
        <ModalActionHistory />
      </ModalSimple>,
      document.getElementById("modal-roots")
    );
  }
  if (display == "SupplierFilterModal") {
    return ReactDOM.createPortal(
      <ModalSimple
        text={"Filter by shipping to customer"}
        secondButton={async () => {
          await dispatch(
            onFilterUpdateWithUser([], "user_suppliers", "user_suppliers")
          );
          dispatch(setNordrentOrderSettings({ page: 1 }));
        }}
        secondButtonText="Clear the supplier filter"
        onClose={() => {
          close();
          // props.updateOrderFilter();
        }}
      >
        <SupplierFilterModal />
      </ModalSimple>,
      document.getElementById("modal-roots")
    );
  }

  if (display == "StatusFilterModal") {
    return ReactDOM.createPortal(
      <ModalSimple
        text={"Filter by status"}
        secondButton={() =>
          dispatch(onFilterUpdateWithUser([], "user_statuses", "statusFilter"))
        }
        secondButtonText="Clear the status filter"
        onClose={() => {
          close();
          // props.updateOrderFilter();
        }}
      >
        <StatusFilterModal options={props.avalaibleStatus} />
      </ModalSimple>,
      document.getElementById("modal-roots")
    );
  }

  if (display == "OrderShowModal") {
    const tilteSpan = (
      <span
        style={{
          fontSize: "1.2rem",
          lineHeight: "27px",
          color: "#000000",
          fontWeight: "700",
        }}
      >
        Order <span className="text-orange">#</span>
        {order_id}
        {/* {this.state.id_order} */}
      </span>
    );

    return ReactDOM.createPortal(
      <ModalSpecial
        text={tilteSpan}
        handleSave={() => { }}
        maskClosable
        onClose={() => {
          if (Object.values(validate_comments).some((d) => d)) {
            if (
              confirm(
                `Are you sure want to close modal with unposted comments ? Unposted: ${Object.entries(
                  validate_comments
                )
                  .filter((d) => d[1])
                  .map((d) => CommentStateType(d[0]))
                  .join(", ")}`
              )
            )
              return close();
          } else {
            close();
          }
        }}
      >
        {loading_order ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "100%" }}
          >
            <Spinner />
          </div>
        ) : !!error_order ? (
          <Alert message={error_order} type="error" />
        ) : (
          <OrderShowModal
            supplySupplier={SupplySupplierData}
            avalaibleStatus={props.avalaibleStatus}
            comments_state={props.comments_state_all}
          />
        )}
      </ModalSpecial>,
      document.getElementById("modal-roots")
    );
  }

  if (display == "OrderCreateModal") {
    const tilteSpan = (
      <span
        style={{
          fontSize: "1.2rem",
          lineHeight: "27px",
          color: "#000000",
          fontWeight: "700",
        }}
      >
        Creating an <span className="text-orange">order</span>
      </span>
    );

    return ReactDOM.createPortal(
      <ModalSpecial
        text={tilteSpan}
        handleSave={() => { }}
        onClose={() => close()}
      >
        <OrderCreateModal
          payment_types={props.payment_types}
          carriers={props.carriers}
          avalaibleStatus={props.avalaibleStatus}
          onClose={() => close()}
        />
      </ModalSpecial>,
      document.getElementById("modal-roots")
    );
  }

  return null;
});

export default Modal;
